
import { computed, defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
import { overlayComposition } from '@/core/modules/overlay/services';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * SVG
         */
        const chartActive = ref<string>('weight-loss');
        const charts: string[] = ['weight-loss', 'viral-load', 'free-drug-exposure', 'histo-score'];

        function togglePopup (chart: string): void {
            chartActive.value = chart;
        }

		return { endpointId, charts, togglePopup, chartActive }
	}

    export default defineComponent({
        setup() {
            return { ...overlayComposition(), ...bespokeComposition() }
        },
    })
